export default function FormsExtensionPricing() {
  const plans = [
    {
      name: '开发者版',
      price: '免费',
      description: '适合个人开发者和小型项目',
      features: [
        '每月1000次API调用',
        '基础表单识别',
        '标准数据提取',
        '社区技术支持',
        '开发文档访问'
      ],
      buttonText: '立即开始',
      popular: false
    },
    {
      name: '专业版',
      price: '¥13,893',
      period: '/年',
      description: '适合中小企业和团队使用',
      features: [
        '每月50,000次API调用',
        '高级表单识别',
        '智能数据验证',
        '优先技术支持',
        'API使用统计',
        '自定义表单模板'
      ],
      buttonText: '开始试用',
      popular: true
    },
    {
      name: '企业版',
      price: '定制',
      description: '适合大型企业和高并发场景',
      features: [
        '无限API调用',
        '私有化部署',
        '定制化开发',
        '7×24小时支持',
        'SLA服务保障',
        '专属客户经理',
        '培训和咨询服务'
      ],
      buttonText: '联系销售',
      popular: false
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>灵活的定价方案</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            选择适合您的<strong>服务套餐</strong>，随时升级或调整
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className={`rounded-2xl p-8 transition-all duration-300 hover:-translate-y-2 ${
                plan.popular 
                  ? 'bg-gradient-to-br from-teal-600 to-cyan-600 text-white shadow-2xl scale-105' 
                  : 'bg-white border-2 border-gray-200 shadow-lg hover:shadow-2xl'
              }`}
            >
              {plan.popular && (
                <div className="inline-flex items-center px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm font-semibold mb-4">
                  <i className="ri-star-line mr-2"></i>
                  最受欢迎
                </div>
              )}
              
              <h3 className={`text-2xl font-bold mb-2 ${plan.popular ? 'text-white' : 'text-gray-900'}`}>
                <strong>{plan.name}</strong>
              </h3>
              
              <div className="mb-4">
                <span className={`text-5xl font-bold ${plan.popular ? 'text-white' : 'text-gray-900'}`}>
                  {plan.price}
                </span>
                {plan.period && (
                  <span className={`text-lg ${plan.popular ? 'text-white/80' : 'text-gray-500'}`}>
                    {plan.period}
                  </span>
                )}
              </div>
              
              <p className={`mb-8 ${plan.popular ? 'text-white/90' : 'text-gray-600'}`}>
                {plan.description}
              </p>
              
              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className={`ri-check-line text-xl mr-3 flex-shrink-0 ${
                      plan.popular ? 'text-white' : 'text-teal-600'
                    }`}></i>
                    <span className={plan.popular ? 'text-white/90' : 'text-gray-600'}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
              
              <button className={`w-full py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                plan.popular
                  ? 'bg-white text-teal-600 hover:bg-gray-100'
                  : 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white hover:from-teal-700 hover:to-cyan-700'
              }`}>
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            需要更多信息？查看<a href="#" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">完整功能对比</a>
          </p>
          <p className="text-sm text-gray-500">
            所有方案均支持30天无理由退款
          </p>
        </div>
      </div>
    </section>
  );
}
